import { z } from 'zod';

/**
 * What a ledger row's money bought (P31).
 *
 * - `purchase` — a subscription's first charge, or any direct plan order.
 * - `renewal` — a subscription's later charge (a store `RENEWAL` /
 *   `UNCANCELLATION`), and the failed attempt at one (`BILLING_ISSUE`).
 * - `fee` — a one-off (D9a), whichever door it came through.
 *
 * `SUBSCRIPTION_EXTENDED`, `EXPIRATION`, `CANCELLATION` (auto-renew off),
 * `PRODUCT_CHANGE`, `TRANSFER` and `TEST` move no money and write no row.
 */
export const PAYMENT_KINDS = ['purchase', 'renewal', 'fee'] as const;

export const PaymentKindSchema = z.enum(PAYMENT_KINDS);

export type PaymentKind = (typeof PAYMENT_KINDS)[number];

const KIND_SET: ReadonlySet<string> = new Set(PAYMENT_KINDS);

export function isPaymentKind(value: string): value is PaymentKind {
  return KIND_SET.has(value);
}
